export const SET = '/accidents/set';
